import { api } from '../api';
import { useQuery, UseQueryResult } from 'react-query';
import { AxiosError } from 'axios';
import { FirmNotApplicableDescription } from '../types/firm';
import { useFirmContext } from '../providers/FirmProvider';
import { useHasFeatureAccess } from '../hooks/use-has-feature-access';

type GetFirmNotApplicableDescriptionsReponse = {
    notApplicableDescriptions: FirmNotApplicableDescription[];
};

async function getFirmNotApplicableDescriptions(firmId: string): Promise<GetFirmNotApplicableDescriptionsReponse> {
    const { data } = await api.get(`/firms/${firmId}/quick-descriptions/not-applicable-descriptions`);
    return data;
}

export function useFirmNotApplicableDescriptions(): UseQueryResult<GetFirmNotApplicableDescriptionsReponse, AxiosError> {
    const hasFeatureAccess = useHasFeatureAccess('firm-descriptions:read');
    const { id: firmId } = useFirmContext();
    return useQuery(['firm', firmId, 'not-applicable-descriptions'], () => getFirmNotApplicableDescriptions(firmId), {
        keepPreviousData: true,
        enabled: hasFeatureAccess,
    });
}
